import React, { useRef, forwardRef, useState, useEffect } from 'react'
import Color from 'color'
import { useLoader, useFrame } from '@react-three/fiber'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { THREE } from 'expo-three'
import { Text } from '@react-three/drei'

import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'

import modelObj from '../../../assets/arena/towerSquare_bottomB.obj'
import modelMtl from '../../../assets/arena/towerSquare_bottomB.mtl'


const loaderObj = new OBJLoader();
const loaderMtl = new MTLLoader();

const textureLoader = new THREE.TextureLoader()

export default forwardRef((props, ref) => {
  const fwdRef = ref || useRef()
  const [geometry, setGeometry] = useState()
  const [materialOffsetDirection, setMaterialOffsetDirection] = useState(1)
  const { texture, tint = "#fff", name = '', ...moreProps } = props

  // const threeTone = textureLoader.load(require('../../../assets/threeTone.jpg'));
  // threeTone.minFilter = THREE.NearestFilter;
  // threeTone.magFilter = THREE.NearestFilter;
  
  // const matTest = new THREE.MeshBasicMaterial({ color: 'lime' })
  // const materialChassis = colorPalette[0] ? new THREE.MeshLambertMaterial({ color: colorPalette[0], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })
  // const materialDeco = colorPalette[1] ? new THREE.MeshLambertMaterial({ color: colorPalette[1], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })
  // const materialCore = colorPalette[2] ? new THREE.MeshLambertMaterial({ color: colorPalette[2], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })
  // const materialDome = colorPalette[3] ? new THREE.MeshLambertMaterial({ color: colorPalette[3], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })
  const materialPurple =  new THREE.MeshLambertMaterial({ color: tint })
  const materialStone = new THREE.MeshLambertMaterial({ color: Color(tint).darken(0.5).toString() })
  const materialStoneDark = new THREE.MeshLambertMaterial({ color: Color(tint).darken(0.8).toString() })

  const loadObject = async () => {
    const mtl = loaderMtl.parse(modelMtl)
    mtl.preload();
    loaderObj.setMaterials(mtl)
    const obj = loaderObj.parse(modelObj)
    obj.children[0].material[0] = materialPurple// purple
    obj.children[0].material[1] = materialStone// stone
    obj.children[0].material[2] = materialStoneDark// stoneDark
    obj.children[0].receiveShadow = true
    setGeometry(obj)
  }
  useEffect(loadObject,[])

  return (
    <>
      <group
        position={[0, -1.9, 7.9]}
      >
        <Text
          // font={require('../../../assets/fonts/Sandoval.ttf')}
          fontSize={1}
          anchorX="center" // default
          anchorY="middle" // default
          material={new THREE.MeshBasicMaterial({color: tint, opacity: 0.5, transparent: true })}
        >
          {name.toUpperCase()}
        </Text>
      </group>
      <group
        ref={fwdRef}
        {...moreProps}
      >
        {geometry &&
          <primitive object={geometry} />
        }
      </group>
    </>
  )
})